import {
  CircularProgress,
  CircularProgressLabel,
  IconButton,
} from "@chakra-ui/react";
import { enurgenBlue, enurgenDarkActive } from "@duet/ui/theme/color";
import { Fragment, useMemo } from "react";
import { TbPlayerStop } from "react-icons/tb";
import { ConfirmModal } from "~/components/ConfirmModal/ConfirmModal";
import { useStopRunningSimulationMutation } from "~/gql/generated";
import { useAppDispatch } from "~/redux/store";
import { useProjectRunningSimulationPolling } from "../../projectDesign/hooks/useRunningProjectSimulationPolling";
import { setSimulationInProgress } from "../projectSlice";

export function AppBarSimProgress(props: { projectId: string }) {
  const { simulationInProgress: runningSim } =
    useProjectRunningSimulationPolling({
      projectId: props.projectId,
    });

  const completedTasks = runningSim?.duet_job?.completed_tasks ?? 0;
  // TODO: this is a hack to account for post processing until we report on post processing tasks
  const actualTotalTasks = runningSim?.duet_job.total_tasks ?? 0;
  const toalTasksWithPostProcessing = actualTotalTasks + 1;

  const isPostProcessing = runningSim?.duet_job.stage === "post_processing";

  const dispatch = useAppDispatch();

  const [stopRunningSimulationMutation, stopRunningSimulationResult] =
    useStopRunningSimulationMutation();

  const inProgressPct = useMemo(() => {
    const total = toalTasksWithPostProcessing;
    const completed = completedTasks ?? 0;

    if (total && total > 0) {
      return (completed / total) * 100;
    }
    return 0;
  }, [toalTasksWithPostProcessing, completedTasks]);

  if (!runningSim) return null;

  return (
    <Fragment>
      <CircularProgress
        isIndeterminate={!inProgressPct || isPostProcessing}
        color={enurgenBlue.toHexString()}
        value={inProgressPct}
        size={7}
      >
        <CircularProgressLabel fontSize={14} ml={8}>
          {Math.floor(inProgressPct)}%
        </CircularProgressLabel>
      </CircularProgress>
      <ConfirmModal
        header="Confirm Stopping Simulation"
        content="Are you sure if you want to stop this simulation? This will stop the simulation and you will lose all progress."
        primaryAction={{
          isLoading: stopRunningSimulationResult.isLoading,
          content: "Stop Simulation",
          colorScheme: "red",
        }}
        onConfirm={async () => {
          await stopRunningSimulationMutation({
            project_id: props.projectId,
            id: runningSim.id,
          });
          dispatch(setSimulationInProgress(null));
        }}
        trigger={
          <IconButton
            icon={<TbPlayerStop />}
            _hover={{
              background: enurgenDarkActive.toHexString(),
              cursor: "pointer",
            }}
            size="xs"
            colorScheme="white"
            isLoading={stopRunningSimulationResult.isLoading}
            aria-label="Stop Simulation"
            ml={8}
          />
        }
      />
    </Fragment>
  );
}
